module.exports = __webpack_public_path__ + "static/fulfillment-booking@2x-f9e0e5950084cdf0a40cd01bef9d1466.png";